/**
 * Enumeration of possible user setting names.  Some of these map exactly to legacy names.
 */
var VIEWER_STYLE_PREFIX = "viewer.style";

export default {

    //Is the UI in accessible mode
    ACCESSIBLE: "accessible.mode",

    // the currently selected admin menu item.
    ADMIN_MENU_CURRENT: "AdminMenuCurrent",

    // the prefix for settings that store expanded state of the admin menu
    ADMIN_MENU_PREFIX: "AdminMenu_",

    NOTES_SORT_DIR: "notes.sort.dir",

    NOTES_FILTER: "notes.filter",

    // Whether to show a warning when modifying group feature rights
    SHOW_FEATURE_RIGHT_WARNING: "featureRights.showWarning",

    // Whether to show a warning when modifying system properties
    SHOW_SYSTEM_PROPERTY_WARNING: "systemProperties.showWarning",

    // Whether to show a warning when modifying themes
    SHOW_THEMES_WARNING: "themes.showWarning",

    // Whether to show header description text
    SHOW_HEADER_DESCRIPTIONS: "app.showHeaderDescriptions",

    // Whether long text should wrap in grids in Search and Jobs
    WORD_WRAP_IN_GRIDS: "app.gridWordWrap",

    // The user's preferred viewer
    VIEWER_SELECTED_VIEWER: "viewer.selectedViewer",

    // whether the case sensitive checkbox is checked or not
    VIEWER_FIND_CASE_SENSITIVE: "viewer.search.case",

    // the last fit-to the user set or none if manually zoomed
    VIEWER_FIT_TO: "viewer.fit.to",

    // style for viewer rectangle
    VIEWER_STYLE_RECTANGLE: VIEWER_STYLE_PREFIX + ".RECTANGLE",

    // style for viewer highlight
    VIEWER_STYLE_HIGHLIGHT: VIEWER_STYLE_PREFIX + ".HIGHLIGHT",

    // style for viewer ellipse
    VIEWER_STYLE_ELLIPSE: VIEWER_STYLE_PREFIX + ".ELLIPSE",

    // style for viewer arrow
    VIEWER_STYLE_ARROW: VIEWER_STYLE_PREFIX + ".ARROW",

    // style for viewer line
    VIEWER_STYLE_LINE: VIEWER_STYLE_PREFIX + ".LINE",

    // style for viewer freehand
    VIEWER_STYLE_FREEHAND: VIEWER_STYLE_PREFIX + ".FREEHAND",

    // style for viewer text
    VIEWER_STYLE_TEXT: VIEWER_STYLE_PREFIX + ".TEXT",

    // Whether tab/enter on the last field in indexing moves to the next document
    INDEXING_NEXT_DOCUMENT_ON_ENTER: "indexing.next.document.on.enter",

    // Whether save moves to the next document in indexing
    INDEXING_NEXT_DOCUMENT_ON_SAVE: "indexing.next.document.on.save",

    // Whether to retain the category and document type when switching to a new document
    INDEXING_RETAIN_CATEGORY_DOCTYPE: "indexing.save.catDocType",

    // Whether to save indexing data automatically when checking in a batch
    INDEXING_SAVE_ON_CHECK_IN: "indexing.save.batch.on.check.in",

    // Whether to check out the next batch automatically after committing a batch
    INDEXING_CHECK_OUT_ON_COMMIT: "indexing.next.batch.on.commit",

    // Whether the auto refresh batches function is paused
    INDEXING_BATCH_REFRESH_PAUSE: "batch.refresh.pause",

    // How often to automatically refresh batches (milliseconds)
    INDEXING_BATCH_REFRESH_TIMER: "batch.refresh.timer",

    // details or thumbs view in batches
    INDEXING_BATCH_VIEW_TYPE: "batches.viewType",

    // whether to show the pointers item in the flags column in indexing grid view
    INDEXING_POINTER_FLAG: "indexing.flag.pointer",

    // whether to show the checked out item in the flags column in indexing grid view
    INDEXING_EDITING_FLAG: "indexing.flag.edting",

    // whether to show the locked item in the flags column in indexing grid view
    INDEXING_LOCKED_FLAG: "indexing.flag.locked",

    // whether to show the locked item in the flags column in indexing grid view
    INDEXING_PREDICT_TAB: "indexing.predict.tab",

    // whether auto focus the indexing panel when a doc is selected in the batches panel
    INDEXING_FOCUS_ON_BATCH_DOC_SELECT: "indexing.focus.on.batch.doc.select",

    // whether to show the document flags column (legacy)
    SEARCH_RESULTS_DOCUMENT_FLAGS: "search.results.showDocumentFlags",

    // whether to show the file type column (document, form, checklist)
    SEARCH_RESULTS_FILE_TYPE: "search.results.file.type",

    // whether to show the pointer flag
    SEARCH_RESULTS_POINTER_FLAG: "search.results.flag.pointer",

    // whether to show the notes flag
    SEARCH_RESULTS_NOTES_FLAG: "search.results.flag.notes",

    // whether to show the editing flag
    SEARCH_RESULTS_EDITING_FLAG: "search.results.flag.editing",

    // whether to show the editing flag
    SEARCH_RESULTS_SMART_FOLDER_FLAG: "search.results.flag.smart.folder",

    // whether to show the locked flag
    SEARCH_RESULTS_LOCKED_FLAG: "search.results.flag.locked",

    // view mode for Document Search Results
    SEARCH_RESULTS_VIEW_TYPE: "search.results.viewType",

    // search page limit
    SEARCH_PAGE_LIMIT: "search.currentPageLimit",

    // search last selected
    SEARCH_LAST_SELECTED: "searching.lastSelectedSearchId",

    // search last tab opened
    SEARCH_LAST_TAB: "search.lastTab",

    //Search - last folder type selected
    SEARCH_LAST_FOLDER_TYPE: "search.lastFolderType",

    //Number of milliseconds to wait before refreshing job view list
    BPM_REFRESH_TIMER: "bpm.refresh.timer",

    //Should job views automatically refresh
    BPM_REFRESH_PAUSE: "bpm.refresh.pause",

    //The time when user messages were last viewed
    MESSAGES_USER_LAST_VIEWED: "messages.user.lastViewed",

    //The time when server messages were last viewed by this user
    MESSAGES_SERVER_LAST_VIEWED: "messages.server.lastViewed",

    // the time when gateway messages were last viewed by this user
    MESSAGES_GATEWAY_LAST_VIEWED: "messages.gateway.lastViewed",

    // the time when gateway messages were last viewed by this user
    MESSAGES_GATEWAY_SEND_EMAIL: "messages.gateway.sendEmail",

    // when to auto hide success notifications
    NOTIFICATIONS_SUCCESS_HIDE: "notify.hide.success",

    // when to auto hide error notifications
    NOTIFICATIONS_ERROR_HIDE: "notify.hide.error",

    // last selected printer id
    PRINT_LAST_PRINTER: "printing.defaultPrinterId",

    // printer orientation - last selected when printing documents is saved here
    PRINT_ORIENTATION: "printing.pageOrientation",

    // number of copies to print - last set when printing documents is saved here
    PRINT_COPIES: "printing.numberOfCopies",

    // whether the duplex option is set for printing documents
    PRINT_DUPLEX: "printing.paging",

    // whether the collate option is set for printing documents
    PRINT_COLLATE: "printing.collated",

    // whether the option to center the document on the page is ste, for printing documents
    PRINT_CENTER: "printing.centerOnPage",

    // whether documents are printed with redactions - can be changed in the UI, and will be overridden if lacking permissions
    PRINT_REDACTIONS: "printing.redaction",

    // whether documents are printed with markup - can be changed in the UI, and will be overridden if lacking permissions
    PRINT_MARKUP: "printing.annotations",

    // whether print jobs are sent with a cover sheet, when printing documents
    PRINT_COVER: "printing.beginningCoverSheet",

    PRINT_IS_SERVER: "printing.isServer",

    // Show the thumbnails column in the viewer
    SHOW_VIEWER_THUMBNAILS: "viewer.showThumbs.documentEditMode",

    // Whether icon text in Menu95 is toggled on or off
    SHOW_ICON_TEXT_BATCHES: "menubar.icons.textToggleBatchPanel_menuBar",
    SHOW_ICON_TEXT_VIEWER: "menubar.icons.textToggleDocumentPreviewPanel_menuBar",
    SHOW_ICON_TEXT_DOC_INFO: "menubar.icons.textToggleDocumentInfoPanel_menuBar",
    SHOW_ICON_TEXT_FOLDERS: "menubar.icons.textToggleFoldersPanel_menuBar",
    SHOW_ICON_TEXT_FORMS: "menubar.icons.textToggleFormsPanel_menuBar",
    SHOW_ICON_TEXT_INDEXING: "menubar.icons.textToggleIndexPanel_menuBar",
    SHOW_ICON_TEXT_JOBS: "menubar.icons.textToggleJobsPanel_menuBar",
    SHOW_ICON_TEXT_JOB_VIEWS: "menubar.icons.textToggleJobViewsPanel_menuBar",
    SHOW_ICON_TEXT_MY_DESKTOP: "menubar.icons.textToggleDesktopPanel_menuBar",
    SHOW_ICON_TEXT_RECORDS_MANAGEMENT: "menubar.icons.textToggleRecordsManagementPanel_menuBar",
    SHOW_ICON_TEXT_SEARCH: "menubar.icons.textToggleSearchPanel_menuBar",
    SHOW_ICON_TEXT_SEARCH_RESULTS: "menubar.icons.textToggleSearchResultsPanel_menuBar",

    // Package Items section collapsed in jobs panel
    COLLAPSE_PACKAGE_ITEMS: "jobs.packageItems.collapse",

    // Job Properties section collapsed in jobs panel
    COLLAPSE_JOB_PROPERTIES: "jobs.jobProperties.collapse",

    // whether to prompt when releasing job
    RELEASE_JOB_PROMPT: "jobs.release.prompt",

    // whether to prompt when clearing indexing data
    CLEAR_DOCUMENT_METADATA_PROMPT: "clear.document.metadata.prompt",

    //Was the viewer panel last used externally
    VIEWER_EXTERNAL_STATE: "viewer.lastExternal",

    //Was the forms panel last used externally
    FORMS_EXTERNAL_STATE: "forms.lastExternal",

    BPM_AUTOCONNECT: "bpm.designer.auto",

    BPM_USE_GUIDES: "bpm.designer.use.guides",

    // display grid on form designer canvas
    FORM_DESIGNER_SHOW_GRID: "form.designer.show.grid",

    // use snap when moving form controls on form designer canvas
    FORM_DESIGNER_USE_SNAP: "form.designer.use.snap",

    // whether to prompt when documents are being placed on legal hold
    RM_LEGAL_HOLD: "rm.legalHold",

    //which tab was last viewed in the folders panel
    FOLDER_PANEL_TAB: "folder.panel.tab",

    EDITING_SPLIT_MODE: "editing.split.mode"
};
